
import React from 'react';
import { connect } from 'react-redux';
import ObjectItem from 'components/Object/ObjectItem/ObjectItem';
import * as ConfigTypes from 'config/ConfigTypes';

import { Flow } from 'flow-react';
import { observer } from 'mobx-react';

import * as actions from 'store/actions';

import './ObjectList.scss';

const ObjectList = observer(
    class ObjectList extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                objectlist: []
            }
        }

        updateObjectList = () => {
            const { objectlist } = this.props.mediaObjects;
            if (objectlist) {
                this.setState({ objectlist: objectlist });
            }
        }

        showObjectList = (item, i) => {
            if (this.props.mediaObjects.wpView == ConfigTypes.WORK_LIST) {
                return (<ObjectItem key={`objectlistCard_${i}`} object={item} />)
            }
            return (
                <div key={`objectlist_${i}`} className="col-xxl-3 col-xl-4 col-lg-4 col-md-6">
                    <ObjectItem key={`objectlistCard_${i}`} object={item} />
                </div>)
        }

        showList = () => {
            if (this.props.mediaObjects.wpView == ConfigTypes.WORK_LIST) {
                return (
                    <div className="list-group">
                        {this.state.objectlist.map((item, i) => this.showObjectList(item, i))}
                    </div>
                )
            }
            return (
                <div className="row objectlist-grid">
                    {this.state.objectlist.map((item, i) => this.showObjectList(item, i))}
                </div>
            )
        }

        componentDidUpdate(prev) {
            if (prev.mediaObjects.objectlist != this.props.mediaObjects.objectlist) {
                this.updateObjectList();
            }
        }

        componentDidMount() {
            this.updateObjectList();
        }

        render() {
            return (
                // <div className="objectlist col-10 mx-auto p-0">
                <div className="objectlist p-0">
                    {this.showList()}
                </div>
            )
        }
    }
)

const mapStateToProps = (state) => ({
    mediaObjects: state.media.mediaObjects
});

const mapDispatchToProps = (dispatch) => ({
    updateMediaObjects: (obj) => dispatch(actions.updateMediaObjects(obj)),
    updateAppObjects: (obj) => dispatch(actions.updateAppObjects(obj)),
})

export default Flow.injectFlow(connect(mapStateToProps, mapDispatchToProps)(ObjectList));